<template>
    <div>
        <b-row class="my-3">
            <b-col cols="8" class="align-self-center">
                <b-breadcrumb class="m-0 p-0">
                    <b-breadcrumb-item @click="$router.push('/')">
                        Pages
                    </b-breadcrumb-item>
                    <b-breadcrumb-item @click="$router.push('/pages/' + (page || {}).id + '/messages')">
                        {{ (page || {}).name }}
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active>
                        <strong>{{ form.data.subject }}</strong>
                    </b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col class="align-self-center text-right">
            </b-col>
        </b-row>

        <hr/>

        <b-row class="mb-2">
        </b-row>

        <b-card bg-variant="light">
            <b-form-group
                label-cols-lg="3"
                label="Message"
                label-size="lg"
                label-class="font-weight-bold pt-0"
                class="mb-0"
                :class="{'disabled-to-edit':mode!=='edit'}"
                >
                <b-form-group
                    label-cols-sm="3"
                    label="Subject:"
                    label-align-sm="right"
                    >
                    <b-form-input
                        v-model="form.data.subject"
                        v-base-label-value="mode"
                        />
                    <base-input-error :errors="form.errors.subject" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="3"
                    label="Body:"
                    label-align-sm="right"
                    >
                    <b-form-textarea
                        v-model="form.data.body"
                        placeholder="Auto height textarea"
                        rows="3"
                        v-base-label-value="mode"
                        />
                    <base-input-error :errors="form.errors.body" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="3"
                    label=""
                    label-align-sm="right"
                    label-for="nested-city"
                    class="text-right pt-4"
                    >
                    <template v-if="mode === 'edit'">
                        <b-button @click="save" variant="primary" block>
                            Save
                        </b-button>
                        <template v-if="form.data.id">
                            <b-button @click="cancel" variant="outline-secondary" block>
                                Cancel
                            </b-button>
                            <div class="text-center my-2">
                                or
                            </div>
                            <b-button @click="destroy" variant="outline-secondary" block>
                                Delete
                            </b-button>
                        </template>
                    </template>
                    <template v-else>
                        <b-button @click="edit" variant="outline-secondary" block>
                            Edit
                        </b-button>
                    </template>
                </b-form-group>
            </b-form-group>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        page_id: {
            type: String,
            required: true
        },
        message_id: {
            type: String,
            required: true
        },
        _mode: {
            type: String,
            required: false,
            'default': () => {
                return 'detail'
            }
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_pages',
        ])
    },
    data() {
        return {
            form: {
                data: {},
                errors: {},
                mode: 'detail', // detail(default), edit
            },
            page: {},
            timer: null,
        }
    },
    watch: {
        $route: {
            async handler () {
                this.mode = (this._mode === 'edit' || this.message_id === 'new') ? 'edit' : 'detail'
                this.$set(this.form, 'data', {
                    page_id: this.page_id,
                    id: this.message_id === 'new' ? null : this.message_id,
                })

                this.interval()
                this.timer = window.setInterval(this.interval, 1 * 60 * 1000)

            },
            immediate: true
        }
    },
    methods: {
        async fetch () {
            this.fetchMessage()
            this.fetchPage()
        },
        async fetchMessage () {
            if (!this.form.data.id) {
                return
            }

            const response = await this.$store.dispatch('message/index', this.form.data)
            if (this.isResponseError(response)) {
                return false
            }
            this.form.data = response.data
        },
        async fetchPage () {
            const response = await this.$store.dispatch('page/index', this.page_id)
            if (this.isResponseError(response)) {
                return false
            }
            this.page = response.data
        },
        async sync() {
//            this.$set(this.form.search, 'errors', {})
            const response = await this.$store.dispatch('page/syncCustomers', this.id)
//            this.$set(this.form.search, 'errors', this.getResponseValidationErrors(response))
            if (this.isResponseError(response)) {
                return false
            }
            this.$set(this.form.data, 'customer', response.data)
        },
        async save() {
            this.$set(this.form, 'errors', {})

            this.$set(this.form.data, 'page_id', this.page_id)
            const response = await this.$store.dispatch('message/save', this.form.data)

            if (this.isResponseError(response)) {
                this.$set(this.form, 'errors', this.getResponseValidationErrors(response))
                return false
            }

            this.$router.replace('/pages/' + response.data.page_id + '/messages/' + response.data.id)
        },
        async destroy() {
        },
        async cancel() {
            this.$router.replace('/pages/' + this.form.data.page_id + '/messages/' + this.form.data.id)
        },
        async edit() {
            this.$router.replace('/pages/' + this.form.data.page_id + '/messages/' + this.form.data.id + '/edit')
        },
        async interval () {
            this.fetch()
        },
    },
    mounted () {
    },
    destroyed () {
        clearInterval(this.timer)
    },
}
</script>

<style>
.breadcrumb {
    background-color: transparent;
}
.disabled-to-edit input,
.disabled-to-edit textarea {
    border: none;
    background: transparent;
}
</style>
